/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRecord.defs.js'
export * as $defs from './getRecord.defs.js'
